import React from "react";
import * as Icons from "lucide-react";
import { Check, ArrowRight, ShieldCheck } from "lucide-react";
import { PRICING_FEATURES, GUARANTEE, PRICING_NOTE, ADDONS, ADDONS_NOTE } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function Pricing() {
  const r = useReveal();
  return (
    <section id="pricing" className="bg-ls-alt py-20 md:py-28 border-t" style={{ borderColor: "var(--ls-border)" }}>
      <div ref={r.ref} className={`max-w-5xl mx-auto px-5 md:px-8 text-center ${r.className}`}>
        <p className="ls-eyebrow mb-4">The offer</p>
        <h2 className="font-display text-white text-[10vw] sm:text-5xl md:text-6xl mb-4">
          The Never Miss a Job <span className="text-orange">System.</span>
        </h2>
        <p className="text-lg text-[#b7ab9b] max-w-2xl mx-auto mb-12">
          We make sure you stop losing jobs because of missed calls and slow follow-up.
        </p>

        <div
          className="max-w-3xl mx-auto rounded-2xl p-8 md:p-12 text-left relative overflow-hidden"
          style={{
            background: "var(--ls-surface)",
            border: "1px solid var(--ls-border-strong)",
          }}
        >
          <div
            className="pointer-events-none absolute -top-24 -right-24 w-72 h-72 rounded-full opacity-20"
            style={{ background: "radial-gradient(circle, #f26a21, transparent 70%)" }}
          />
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange">Never Miss a Job System</p>
          <div className="flex items-end gap-2 mt-3">
            <span className="font-display text-white text-6xl md:text-7xl">$597</span>
            <span className="text-[#b7ab9b] text-xl font-cond mb-2">/month</span>
          </div>
          <p className="text-[#b7ab9b] mt-2">Website is free. No setup fee. Cancel anytime.</p>
          <p className="text-white font-cond font-bold mt-1">One extra job usually pays for it.</p>

          <a href="#cta" className="btn-orange text-base mt-6">
            Start Booking Jobs <ArrowRight className="w-4 h-4" />
          </a>

          <div className="mt-6 flex items-start gap-3 rounded-lg p-4" style={{ background: "rgba(242,106,33,0.08)", border: "1px solid rgba(242,106,33,0.3)" }}>
            <ShieldCheck className="w-6 h-6 text-orange shrink-0" />
            <p className="text-sm text-[#ece5da] leading-snug">
              <span className="font-bold text-white">{GUARANTEE.title}.</span> {GUARANTEE.body}
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-3 mt-8 pt-8 border-t" style={{ borderColor: "var(--ls-border)" }}>
            {PRICING_FEATURES.map((f) => (
              <div key={f} className="flex items-center gap-3">
                <span
                  className="flex items-center justify-center w-5 h-5 rounded-full shrink-0"
                  style={{ backgroundColor: "var(--ls-orange)" }}
                >
                  <Check className="w-3.5 h-3.5" stroke="#0a0f16" strokeWidth={3} />
                </span>
                <span className="text-[#ece5da]">{f}</span>
              </div>
            ))}
          </div>

          <p className="mt-6 text-sm text-[#a99f92] leading-relaxed border-t pt-6" style={{ borderColor: "var(--ls-border)" }}>
            {PRICING_NOTE}
          </p>
        </div>

        {/* Optional Add-ons */}
        <div className="max-w-3xl mx-auto mt-16 text-left">
          <p className="ls-eyebrow mb-3">Optional Add-ons</p>
          <h3 className="font-display text-white text-3xl md:text-4xl mb-3">
            Want to add more later? <span className="text-orange">Totally up to you.</span>
          </h3>
          <p className="text-[#c7bdae] leading-relaxed mb-8">{ADDONS_NOTE}</p>

          <div className="space-y-3">
            {ADDONS.map((a) => {
              const Icon = Icons[a.icon] || Icons.Plus;
              return (
                <div
                  key={a.title}
                  className="card-dark p-5 flex flex-col sm:flex-row sm:items-center gap-4"
                >
                  <span
                    className="flex items-center justify-center w-12 h-12 rounded-2xl shrink-0"
                    style={{ backgroundColor: "rgba(242,106,33,0.14)" }}
                  >
                    <Icon className="w-5 h-5 text-orange" />
                  </span>
                  <div className="flex-1">
                    <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
                      <h4 className="font-cond font-extrabold text-xl text-white uppercase tracking-wide leading-none">
                        {a.title}
                      </h4>
                      <span className="font-cond font-bold text-orange text-lg">{a.price}</span>
                    </div>
                    <p className="mt-1.5 text-[#d7cdbf] leading-relaxed">{a.body}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
